import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { Provider } from 'react-redux'
import store from './Reducers/store';
// Import slick-carousel CSS styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import WebHeader from './components/WebHeader';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderReactDom = () => {
  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <HashRouter >
          <App />
        </HashRouter>
      </Provider>
    // </React.StrictMode>
  );
};

if (window.cordova) {
  document.addEventListener('deviceready', () => {
    renderReactDom();
  }, false);
} else {
  renderReactDom();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
